import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('elencoAttivita');
export const actions = helper.createActions('elencoAttivita', actionTypes);